import { queryOptions } from '@tanstack/react-query';
import { getAdjusterSignatureQueryFn } from '@/modules/Dashboard/queries/sidebarSignature/getAdjusterSignatureQueryFn.ts';

export const getAdjusterSignatureQueryOptions = (enabled: boolean = true) =>
  queryOptions({
    queryFn: getAdjusterSignatureQueryFn,
    queryKey: ['adjuster-signature'],
    enabled,
  });
